import React from 'react';

const Blogs = () => {
    return (
        <div className="container mx-auto ">
            <img className="w-10/12 h-96 mx-auto mt-16"
                src="https://image.freepik.com/free-vector/coming-soon-background-with-focus-light-effect-design_1017-27277.jpg" />
        </div>
    );
};

export default Blogs;